import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import style from '../../style/components/profile/EmailConfirmationModal.module.scss';
import StyledModal from '../StyledModal';

const EmailConfirmationModal = ({ email, handleCancel, isOpen }) => {
  const { t } = useTranslation();

  return (
    <StyledModal
      isOpen={isOpen}
      closeModal={handleCancel}
      title="Confirmation is pending for the following email"
      cancelButton={{ text: 'Close' }}
    >
      <div className={style.email}>{email}</div>
      <p>{t('profile.emailConfirmation.description')}</p>
    </StyledModal>
  );
};

EmailConfirmationModal.propTypes = {
  email: PropTypes.string,
  handleCancel: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

EmailConfirmationModal.defaultProps = {
  email: '',
};

export default EmailConfirmationModal;
